import { useState } from 'react';
import Metadata from '../components/Metadata';
import { metadata, menuCard } from '../data';

export default function Wines() {
  const [activeTab, setActiveTab] = useState('by-the-glass'); // 'by-the-glass' or 'cellar-list'

  return (
    <div className="bg-wine-950 text-sand-50 min-h-screen font-sans">
      <Metadata title={metadata.wines.title} description={metadata.wines.description} />

      {/* Hero Header */}
      <section className="relative py-24 border-b border-wine-900/40 bg-wine-950 text-center overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/la-fable-wine-pour.jpg"
            alt="La Fable Wine"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-wine-950/90 via-wine-950/70 to-wine-950" />
        </div>

        <div className="relative z-10 mx-auto max-w-3xl px-6 space-y-8">
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-sand-50 tracking-tighter uppercase">
            The Wines
          </h1>

          {/* Sommelier Bio - Split Layout */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center max-w-4xl mx-auto pt-4">
            {/* Image Column */}
            <div className="md:col-span-5 border border-white/10 p-2 bg-zinc-950/50 backdrop-blur-sm">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/david-bf3i7458-web.jpg"
                alt="Davide Piccolo Sommelier"
                className="w-full aspect-[4/5] object-cover grayscale contrast-125"
              />
            </div>

            {/* Text Column */}
            <div className="md:col-span-7 space-y-6 text-left md:pl-4">
              <div className="space-y-2">
                <span className="font-sans text-xs tracking-[0.2em] uppercase text-sand-300 block font-normal">
                  Our Sommelier
                </span>
                <h2 className="font-display text-2xl sm:text-3xl font-black text-sand-50 tracking-tighter uppercase">
                  Davide Piccolo
                </h2>
              </div>
              
              <p className="font-sans text-sm sm:text-base font-normal text-sand-200/80 leading-relaxed">
                Our wine list has been put together by our sommelier and Bar Manager, Davide Piccolo, holder of the WSET Level 4 Diploma.
              </p>

              {/* PDF Downloads */}
              <div className="space-y-3 pt-2">
                <p className="font-sans text-xs font-bold uppercase tracking-widest text-sand-300">
                  Download Full Lists (PDF)
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://assets.auxodev.dk/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/wine-by-the-glass-aug-2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-3 border border-white/10 bg-zinc-950 text-sand-50 text-[10px] uppercase tracking-[0.2em] hover:bg-zinc-900 hover:border-white/30 transition-all duration-300 inline-flex items-center justify-center gap-2 group flex-1 rounded-none"
                  >
                    <i className="fa-solid fa-file-pdf text-xs" />
                    Wine by the glass
                    <i className="fa-solid fa-arrow-up-right-from-square text-[9px]" />
                  </a>
                  <a
                    href="https://assets.auxodev.dk/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/cellar-list-aug-2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-3 border border-white/10 bg-zinc-950 text-sand-50 text-[10px] uppercase tracking-[0.2em] hover:bg-zinc-900 hover:border-white/30 transition-all duration-300 inline-flex items-center justify-center gap-2 group flex-1 rounded-none"
                  >
                    <i className="fa-solid fa-file-pdf text-xs" />
                    Cellar list
                    <i className="fa-solid fa-arrow-up-right-from-square text-[9px]" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Interactive Menu Section */}
      <section className="py-20 bg-[#f7f3eb]">
        <div className="mx-auto max-w-5xl px-6">
          <div className="text-center space-y-4 mb-12">
            <span className="font-sans text-xs tracking-[0.2em] uppercase text-zinc-700 block font-normal">
              Explore Our Selection
            </span>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-zinc-900 tracking-tighter uppercase">
              Online Wine List
            </h2>
            <p className="font-sans text-sm sm:text-base font-normal text-zinc-700 max-w-xl mx-auto leading-relaxed">
              Check out our wines by the glass and cellar list.
            </p>
            <div className="w-12 h-[1px] bg-zinc-300 mx-auto my-2" />
            
            {/* Tab Switcher */}
            <div className="flex justify-center gap-4 pt-4">
              <button
                onClick={() => setActiveTab('by-the-glass')}
                className={`px-6 py-3 text-xs uppercase tracking-[0.2em] transition-all duration-300 border ${
                  activeTab === 'by-the-glass'
                    ? 'bg-zinc-900 text-white border-zinc-900'
                    : 'bg-transparent text-zinc-600 border-zinc-300 hover:border-zinc-900'
                }`}
              >
                Wine by the Glass
              </button>
              <button
                onClick={() => setActiveTab('cellar-list')}
                className={`px-6 py-3 text-xs uppercase tracking-[0.2em] transition-all duration-300 border ${
                  activeTab === 'cellar-list'
                    ? 'bg-zinc-900 text-white border-zinc-900'
                    : 'bg-transparent text-zinc-600 border-zinc-300 hover:border-zinc-900'
                }`}
              >
                Cellar List
              </button>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === 'by-the-glass' ? (
            <div className="space-y-16 max-w-5xl mx-auto">
              {menuCard.wines.map((category, idx) => (
                <div key={idx} className="space-y-6">
                  <div className="flex items-center gap-4 mb-6">
                    <span className="font-display text-sm uppercase tracking-[0.25em] text-zinc-800 font-bold">
                      {category.category}
                    </span>
                    <div className="flex-1 h-[1px] bg-zinc-300/60" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
                    {category.items.map((item, itemIdx) => (
                      <div key={itemIdx} className="group space-y-1">
                        <div className="flex items-baseline justify-between gap-2">
                          <span className="font-display text-base sm:text-lg text-zinc-900 font-bold tracking-tight group-hover:text-zinc-700 transition-colors">
                            {item.name}
                          </span>
                          <div className="flex-1 border-b border-dotted border-zinc-300 mx-2 self-end mb-1.5 min-w-4" />
                          <span className="font-display text-sm sm:text-base font-bold text-zinc-900 whitespace-nowrap shrink-0">
                            {item.price}
                          </span>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between text-xs text-zinc-600 font-normal">
                          <span className="font-sans text-zinc-600 uppercase tracking-wider text-[10px]">
                            {item.producer}
                          </span>
                        </div>
                        {item.desc && (
                          <p className="font-sans text-xs sm:text-sm font-normal text-zinc-700 leading-relaxed pt-1">
                            {item.desc}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="space-y-16 max-w-5xl mx-auto">
              {menuCard.exclusiveWines.map((category, idx) => (
                <div key={idx} className="space-y-6">
                  <div className="flex items-center gap-4 mb-6">
                    <span className="font-display text-sm uppercase tracking-[0.25em] text-zinc-800 font-bold">
                      {category.category}
                    </span>
                    <div className="flex-1 h-[1px] bg-zinc-300/60" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
                    {category.items.map((item, itemIdx) => (
                      <div key={itemIdx} className="group space-y-1">
                        <div className="flex items-baseline justify-between gap-2">
                          <span className="font-display text-base sm:text-lg text-zinc-900 font-bold tracking-tight group-hover:text-zinc-700 transition-colors">
                            {item.name}
                          </span>
                          <div className="flex-1 border-b border-dotted border-zinc-300 mx-2 self-end mb-1.5 min-w-4" />
                          <span className="font-display text-sm sm:text-base font-bold text-zinc-900 whitespace-nowrap shrink-0">
                            {item.price}
                          </span>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:justify-between text-xs text-zinc-600 font-normal">
                          <span className="font-sans text-zinc-600 uppercase tracking-wider text-[10px]">
                            {item.producer}
                          </span>
                        </div>
                        {item.desc && (
                          <p className="font-sans text-xs sm:text-sm font-normal text-zinc-700 leading-relaxed pt-1">
                            {item.desc}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Note */}
          <div className="mt-16 text-center max-w-2xl mx-auto border-t border-zinc-300/60 pt-8">
            <p className="font-sans text-xs sm:text-sm italic text-zinc-700 tracking-wide">
              We have also a cellar list that is being updated regularly - please ask if you´d like to have a peek!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
